(function () {
  const RULES_BY_HANDLE = {
  };

  function applyHandleRules(variantSelectsEl) {
    if (!variantSelectsEl || !Array.isArray(variantSelectsEl.options)) return;
    const productWrapper = variantSelectsEl.closest('.thb-product-detail');
    if (!productWrapper) return;
    const productHandle = (productWrapper.dataset.handle || '').trim().toLowerCase();
    const productRules = RULES_BY_HANDLE[productHandle];
    if (!productRules) return;

    const thumbContainer = productWrapper.querySelector('.product-thumbnail-container');
    if (!thumbContainer) return;

    const selectedOptionValues = variantSelectsEl.options.map((value) => String(value).trim().toLowerCase());
    const matchedOption = selectedOptionValues.find((value) => Object.prototype.hasOwnProperty.call(productRules, value));
    if (!matchedOption) return;

    const rule = productRules[matchedOption];
    if (!rule) return;

    let targetThumb = null;
    if (rule.visibleThumbIndex) {
      const visibleThumbs = Array.from(thumbContainer.querySelectorAll('.product-thumbnail')).filter((thumb) => {
        return thumb.offsetParent !== null;
      });
      targetThumb = visibleThumbs[rule.visibleThumbIndex - 1] || null;
    } else if (rule.thumbIndex) {
      targetThumb = thumbContainer.querySelector(`.product-thumbnail:nth-child(${rule.thumbIndex})`);
    }
    if (!targetThumb) return;

    const productSlider = productWrapper.querySelector('.product-images');
    const thumbSelector = `#${targetThumb.id}`;
    const slideSelector = thumbSelector.replace('#Thumb-', '#Slide-');

    if (typeof variantSelectsEl.setActiveMedia === 'function' && productSlider) {
      variantSelectsEl.setActiveMedia(slideSelector, thumbSelector, productSlider, thumbContainer);
      return;
    }

    targetThumb.click();
  }

  function runForNode(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('variant-selects, variant-radios').forEach((variantSelectsEl) => {
      applyHandleRules(variantSelectsEl);
    });
  }

  document.addEventListener('product:variant-change', function (event) {
    const sectionId = event.detail && event.detail.sectionId;
    if (sectionId) {
      const variantSelectsEl = document.querySelector(`variant-selects[data-section="${sectionId}"], variant-radios[data-section="${sectionId}"]`);
      if (variantSelectsEl) {
        applyHandleRules(variantSelectsEl);
        return;
      }
    }
    runForNode(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runForNode(document);
    });
  } else {
    runForNode(document);
  }
})();
